export { PolicyPipesModule } from './lib/pipes.module';
export * from './lib/pipes/policy.pipes';
